// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2HiwM","title":"InfoRow_title__3Vwn7"};